/** @jsx jsx */
import { useState } from 'react'
import {
  logSentryError,
  useCart,
  useTranslate
} from '@arfabrands/gatsby-theme-assembly'
import { Button, Text, Spinner, jsx } from 'theme-ui'
import { loadStripe } from '@stripe/stripe-js'

const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PK_KEY, {
  stripeAccount: process.env.GATSBY_STRIPE_CONNECTED_ACCOUNT
})

const CheckoutButton = () => {
  const { checkout } = useCart()
  const translate = useTranslate()
  const [buttonIsLoading, setButtonIsLoading] = useState(false)
  const [apiError, setApiError] = useState(null)

  const handleSubmit = async event => {
    if (event) event.preventDefault()

    setButtonIsLoading(true)
    setApiError(null)

    try {
      const cart = await checkout()

      const stripe = await stripePromise
      stripe.redirectToCheckout({
        sessionId: cart.checkoutSessionId
      })
    } catch (error) {
      setApiError(translate('error.api.default'))
      logSentryError(error, { source: 'CheckoutButton' })
    }

    setButtonIsLoading(false)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Button
        sx={{
          color: 'rgb(81, 39, 115)',
          backgroundColor: 'rgb(197, 179, 215)',
          '&:hover': {
            backgroundColor: 'rgb(197, 179, 215)',
            filter: 'brightness(0.9)',
          },
          borderRadius: '0.25rem',
          fontFamily: 'DIN Alternate Bold,Helvetica,Arial,Sans-Serif',
          marginTop: '1rem',
          padding: '12px 16px',
          transition: 'filter 0.15s ease-in-out 0s',
          width: '100%',
        }}
      >
        {buttonIsLoading && (
          <Spinner data-testid="spinner" size="15" color="inherit" />
        )}

        {!buttonIsLoading && (
          <Text variant="link">{translate('cart.checkout')}</Text>
        )}
      </Button>

      {apiError && (
        <Text color="errorDark" variant="textLink" mt="1.5rem">
          {apiError}
        </Text>
      )}
    </form>
  )
}

export default CheckoutButton
